import type { FeatureModule } from "../types";

/**
 * QC listen lives on the Dial console ActionBar (live mix wav in the browser).
 * No dedicated route — do not rewrite Console. No barge.
 */
export const qcFeature: FeatureModule = {
  id: "qc",
  path: "",
  label: "QC",
  nav: false,
};
